import { read, utils } from 'xlsx';

import { ENCUMBRANCE_EXCEL_SHEET_NAME } from '../constants/encumbranceExcelColumns';
import { EncumbrancesExcelRawRow } from '../types/EncumbrancesExcel';
import { mapExcelKeysToUppercase } from './mapExcelKeysToUppercase';

export type ParseEncumbrancesExcelResult =
  | { success: true; rows: EncumbrancesExcelRawRow[] }
  | { success: false; error: string };

export const parseEncumbrancesExcel = async (
  file: File
): Promise<ParseEncumbrancesExcelResult> => {
  try {
    const data = await file.arrayBuffer();
    const workbook = read(data, { cellDates: true });
    const sheet = workbook.Sheets[ENCUMBRANCE_EXCEL_SHEET_NAME];

    if (!sheet) {
      return { success: false, error: 'SHEET_NOT_FOUND' };
    }

    const rawRows = utils.sheet_to_json(sheet, { defval: null });
    const rows = mapExcelKeysToUppercase(rawRows as EncumbrancesExcelRawRow[]);

    return { success: true, rows };
  } catch {
    return { success: false, error: 'SHEET_NOT_FOUND' };
  }
};
